import { Component } from '@angular/core';
import { AppConstants } from '../../app.constants';
import { AuthDataInterface } from '../../core/models/view-models/account-models/auth-data.interface';
import { LicenseService } from '../../core/services/http-services/license.service';

@Component({
    template: ''
})
export class ErrorPagesComponent {
    public errorCode: number;
    public errorTitle: string;
    public errorDescription: string;
    public errorLink: string = '/';
    public errorLinkTitle: string = 'Return to main dashboard';

    constructor(
        protected readonly licenseService: LicenseService
    ) {
        const authData: AuthDataInterface = JSON.parse(localStorage.getItem(AppConstants.AUTH_DATA_NAME));
        const isNavigateToPdfPage: boolean = authData && authData.roles
            && authData.roles.split(',').includes(AppConstants.PDF_ASSIGNER_ROLE) && this.licenseService.licenseStatusModel
            && this.licenseService.licenseStatusModel.AllowedFeatures.includes(AppConstants.PDF_FILE_TYPE);

        if (isNavigateToPdfPage) {
            this.errorLink = '/PdfAssigner';
            this.errorLinkTitle = 'Return to pdf assigner';
        }
    }
}
